import { ENTITLEMENT_LIST, LOADER_IDENTIFIER } from "./constants";

const emptyState = {
  [LOADER_IDENTIFIER]: false,
  [ENTITLEMENT_LIST]: [],
};

export default emptyState;
